"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;
var _react = _interopRequireDefault(require("react"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _styles = require("@material-ui/core/styles");
var _Typography = require("./Typography");
var _core = require("@material-ui/core");
var _pittaModules = require("@thingsw/pitta-modules");
var _excluded = ["title", "widthLarge", "setting", "blueTooltip"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    popper: _defineProperty({
      maxWidth: function maxWidth(props) {
        return props.widthLarge ? 312 : 280;
      }
    }, theme.breakpoints.up("xs"), {
      maxWidth: "auto"
    }),
    tooltip: _defineProperty({
      maxWidth: 260,
      backgroundColor: _pittaModules.LightColors.primary["1"],
      boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.14), 0px 1px 1px rgba(0, 0, 0, 0.12), 0px 0px 3px rgba(0, 0, 0, 0.2)"
    }, theme.breakpoints.up("xs"), {
      maxWidth: 312,
      // mantis - 12369, 텍스트 가운데 정렬 가능하도록 스타일 추가(Leehj)
      textAlign: function textAlign(props) {
        return props.textCenter ? "center" : "auto";
      }
    })
  };
});

// UXUI 파란툴팁 추가 (Leehj)
var useInfoTooltipStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    popper: _defineProperty({
      top: "6px !important",
      left: "-1px !important",
      maxWidth: function maxWidth(props) {
        return props.widthLarge ? 312 : 280;
      }
    }, theme.breakpoints.up("xs"), {
      maxWidth: "auto"
    }),
    tooltip: _defineProperty({
      padding: "5px 10px 3px",
      maxWidth: 260,
      backgroundColor: _pittaModules.LightColors.primary["7"],
      borderRadius: 6,
      boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.14), 0px 1px 1px rgba(0, 0, 0, 0.12), 0px 0px 3px rgba(0, 0, 0, 0.2)",
      "&::after": {
        position: "absolute",
        content: "''",
        borderTop: "0px solid transparent",
        borderLeft: "7px solid transparent",
        borderRight: "7px solid transparent",
        borderBottom: "7px solid ".concat(_pittaModules.LightColors.primary["7"]),
        top: -5,
        left: "46%"
      }
    }, theme.breakpoints.up("xs"), {
      maxWidth: 312
    }),
    tooltipPlacementBottom: {
      margin: 0
    },
    tooltipPlacementTop: {
      margin: 0
    }
  };
});
var useSettingStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    popper: _defineProperty({
      maxWidth: function maxWidth(props) {
        return props.widthLarge ? 312 : 280;
      }
    }, theme.breakpoints.up("xs"), {
      maxWidth: "auto"
    }),
    tooltip: _defineProperty({
      padding: "5px 8px 3px",
      maxWidth: 260,
      backgroundColor: _pittaModules.LightColors.primary["1"],
      boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.14), 0px 1px 1px rgba(0, 0, 0, 0.12), 0px 0px 3px rgba(0, 0, 0, 0.2)"
    }, theme.breakpoints.up("xs"), {
      maxWidth: 270
    }),
    tooltipPlacementLeft: {
      margin: "0 5px"
    },
    tooltipPlacementRight: {
      margin: "0 5px"
    }
  };
});
var Tooltip = function Tooltip(props) {
  var _props$enterTouchDela;
  var title = props.title,
    widthLarge = props.widthLarge,
    setting = props.setting,
    blueTooltip = props.blueTooltip,
    restProps = _objectWithoutProperties(props, _excluded);
  var classes = useStyles(props);
  var settingClasses = useSettingStyles(props);
  // 툴팁 ux-ui프로젝트에서 사용할 파란툴팁 css적용
  var blueTooltipClasses = useInfoTooltipStyles(props);
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default
  // UXUI 22.10.27 디자인변경 - 파란툴팁 없는 것으로 변경되어 주석 (Leehj)
  // open={setting}
  , _extends({
    classes: setting ? settingClasses : blueTooltip ? blueTooltipClasses : classes
  }, restProps, {
    enterTouchDelay: (_props$enterTouchDela = props.enterTouchDelay) !== null && _props$enterTouchDela !== void 0 ? _props$enterTouchDela : 0
    // mantis - 9436, iOS Safari: 15.4에서 깜빡거리는 이슈 수정(LeeHJ).
    ,
    TransitionComponent: _core.Fade,
    title: /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
      category: "Default",
      variant: "Caption",
      htmlColor: _pittaModules.LightColors.primary["0"]
    }, title)
  }));
};
exports.Tooltip = Tooltip;